import type { MenuItem, MenuWidgetData } from '@web/widgets/menu/type/menu-widget.type';
import type { SelectedFileExtended } from '@common/types/file.type';
import type { EMenuLogoPosition } from '@common/enums';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EButtonLinkType, ESize } from '@common/enums';
import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';

import { getStyles } from './menu-view.component.styles';

import { BLANK_LOGO } from '@web/widgets/image/constants/image.consts';
import { EffectTypes } from '@web/shared/components/web-hover-effects/types';
import { environment } from '@web-env/environment';
import { formatFileUrl, formatFileUrlWithResize } from '@components/sp-file-manager/src/helpers';
import { SpDirectivesModule } from '@common/directives/directives.module';

@Component({
    selector: 'web-menu-view',
    templateUrl: './menu-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SpDirectivesModule],
})
export class MenuViewComponent extends WebBaseViewComponent<MenuWidgetData> {
    protected getStyles = getStyles;
    public ESize = ESize;

    public get isLogo(): boolean {
        return this.widgetData.isLogo;
    }

    public get logoWidth(): number {
        return this.widgetData.logoWidth;
    }

    public get image(): string {
        return BLANK_LOGO;
    }

    public get uploadImage(): SelectedFileExtended {
        return this.widgetData.uploadImage;
    }

    public get logoPosition(): EMenuLogoPosition {
        return this.widgetData.logoPosition;
    }

    public get menuList(): MenuItem[] {
        return this.widgetData.menuList;
    }

    public get iconSize(): ESize {
        return this.widgetData.iconSize;
    }

    public getTarget(item: MenuItem): string {
        return item.isTargetBlank ? '_blank' : '_self';
    }

    public getHref(item: MenuItem): string {
        const { linkUrl, linkType } = item;
        const trimmedValue = linkUrl?.trim() || '';

        switch (linkType) {
            case EButtonLinkType.phone:
                return `tel:${trimmedValue}`;
            case EButtonLinkType.email:
                return `mailto:${trimmedValue}`;
            case EButtonLinkType.link:
            default:
                return trimmedValue;
        }
    }

    public get animationClass(): string {
        return this.widgetData?.hoverEffects?.type === EffectTypes.animation
            ? this.widgetData?.hoverEffects?.animationType
            : null;
    }

    public getVisibleSubmenuItemList(item: MenuItem): boolean {
        if (item?.submenuList) {
            return Boolean(item.submenuList.find((el) => el.isVisible));
        } else {
            return false;
        }
    }

    public get logoImageSrc(): string {
        return formatFileUrlWithResize(this.uploadImage, environment.fileManagerCdnUrl, 720);
    }

    public get logoImageFallbackSrc(): string {
        return formatFileUrl(this.uploadImage, environment.fileManagerCdnUrl);
    }
}
